import { ReceiptTotalComponent } from './receipt-total.component';

export default angular
  .module('sfMobile.components.receipt-total', [
    'sfMobile.constants.question-product',
  ])
  .component('sfReceiptTotal', ReceiptTotalComponent).name;
